import { inject, Injectable } from '@angular/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { TranslocoService } from '@jsverse/transloco';

/**
 * Translated screen-reader and button labels for every datepicker (D-3).
 * The numeric `formatYearRange*` defaults are inherited unchanged. Labels are
 * read once: the language is fixed for the page lifetime (D2).
 */
@Injectable()
export class TranslatedDatepickerIntl extends MatDatepickerIntl {
    private readonly _transloco = inject(TranslocoService);

    override calendarLabel = this._t('calendar');
    override openCalendarLabel = this._t('openCalendar');
    override closeCalendarLabel = this._t('closeCalendar');
    override prevMonthLabel = this._t('prevMonth');
    override nextMonthLabel = this._t('nextMonth');
    override prevYearLabel = this._t('prevYear');
    override nextYearLabel = this._t('nextYear');
    override prevMultiYearLabel = this._t('prevMultiYear');
    override nextMultiYearLabel = this._t('nextMultiYear');
    override switchToMonthViewLabel = this._t('switchToMonthView');
    override switchToMultiYearViewLabel = this._t('switchToMultiYearView');
    override startDateLabel = this._t('startDate');
    override endDateLabel = this._t('endDate');

    private _t(key: string): string {
        return this._transloco.translate(`common.datepicker.${key}`);
    }
}
